var _g, _script;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgNearby = function SvgNearby(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ebf9hgyjag41",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 30",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ebf9hgyjag42",
    transform: "matrix(1.66000000000000 0 0 1.66000000000000 0.06000000000000 0.06000000000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ebf9hgyjag43"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "ebf9hgyjag44",
    rx: 4.5,
    ry: 2,
    transform: "matrix(1 0 0 1 9 13.50000000000000)",
    opacity: 0,
    fill: "none",
    fillRule: "evenodd",
    stroke: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "ebf9hgyjag45",
    rx: 8.5,
    ry: 4,
    transform: "matrix(1 0 0 1 9 13.50000000000000)",
    opacity: 0,
    fill: "none",
    fillRule: "evenodd",
    stroke: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "ebf9hgyjag46",
    r: 1.5,
    transform: "matrix(1 0 0 1 9 2)",
    fill: "currentColor",
    fillRule: "evenodd",
    stroke: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "ebf9hgyjag47",
    d: "M9,4.500000C9.690356,4.500000,10.315356,4.779822,10.767767,5.232233C11.220178,5.684644,11.500000,6.309644,11.500000,7L11.500000,7L11.500000,9.500000L6.500000,9.500000L6.500000,7C6.500000,6.309644,6.779822,5.684644,7.232233,5.232233C7.684644,4.779822,8.309644,4.500000,9,4.500000Z",
    fill: "currentColor",
    fillRule: "evenodd",
    stroke: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "ebf9hgyjag48",
    d: "M10.390098,9.500000L9.713664,12.882171L9.590098,13.500000L8.409902,13.500000L7.609902,9.500000L10.390098,9.500000Z",
    fill: "currentColor",
    fillRule: "evenodd",
    stroke: "currentColor",
    strokeWidth: 1
  })))), _script || (_script = /*#__PURE__*/React.createElement("script", null)));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgNearby);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/nearby.d00e1b84f47904a39f258e758768bb19.svg";